<template>
  <dashboard-widget title="SHOPIFY ORDERS PROCESSED" :zoomed="zoomed" :width="width" :enableDelete="enableDelete"
                      @zoom="$emit('zoom','DashboardShopify')"
                      @delete="$emit('delete','DashboardShopify')"
                      @close="$emit('close')">
    <div ref="chart">
      <div v-if="invalid" class="text-center mt-16">The Shopify add-on has not been installed</div>
    </div>
  </dashboard-widget>
</template>

<script>
import {format,add} from 'date-fns'

export default {
  name: 'DashboardShopify',
  props: {
    zoomed: {type:Boolean, required:false, default:false},
    width: {type:Number, required:false, default:290},
    enableDelete: {type: Boolean, required:false, default:false}
  },
  data() {
    return {
      invalid: false,
      from: '',
      to: '',
      chart: null,
      summaryList: [],
      options: {chartArea:{height:this.zoomed?'70%':'90%',width:'90%',left:40},
                fontSize:this.zoomed?12:10,
                height:this.zoomed?440:250,
                colors:['red','green'],
                vAxis:{format: '#,###',gridlines:{count:4},minorGridLines:{count:0},mmminValue:0,viewWindow:{min:0}},
                hAxis:{textPosition:this.zoomed?'out':'none',showTextEvery:5,slantedText:true,viewWindow:{min:1}},
                legend:{ position: "top", alignment:'center'}}
    }
  },
  computed: {
    drawer() {
      return this.$store.state.drawer;
    }
  },
  created() {
    this.to = format(new Date(), 'yyyy-MM-dd');
    this.from = format(add(new Date(), {days:-29}), 'yyyy-MM-dd');
    this.invalid = !this.$store.getters.company.addOns.includes('Shopify');
  },
  watch: {
    dark() {
      this.draw();
    },
    drawer() {
      this.draw();
    }
  },
  async mounted() {
    if (this.invalid)
      return;

    const results = await this.$apiCall(`query DashboardShopify($from:Date!,$to:Date!) {
                                          shopifySummary(from:$from, to:$to) {
                                            date,success,error
                                          }
                                         }`, {from:this.from, to:this.to}, false, 'shopify');
    if (!results.error) {
      this.summaryList = results.data.shopifySummary;

      if (window.google) {
        window.google.charts.load('current', {'packages':['corechart']});
        window.google.charts.setOnLoadCallback(() => {
          if (this.$refs.chart == undefined)
            return;
          this.chart = new window.google.visualization.LineChart(this.$refs.chart);
          this.draw();
        });
      }
    }
  },
  methods: {
    draw() {
      if (this.chart === null)
        return;

      const dataLineChart = [["Period","Error",{role:"tooltip",type:"string"},"Success",{role:"tooltip",type:"string"}]];
      let date = this.from;
      while (date <= this.to) {
        const summary = this.summaryList.find(s => s.date === date) || {success:0, error:0};
        dataLineChart.push([date,
                            summary.error, `${date}\nErrors: ${summary.error}`,
                            summary.success, `${date}\nSuccesses: ${summary.success}`]);
        date = format(add(new Date(date+'T00:00:00'), {days:1}), 'yyyy-MM-dd');
      }

      const data = window.google.visualization.arrayToDataTable(dataLineChart);
      this.options.width = this.zoomed ? 480 : this.width-30;
      this.chart.draw(data, this.options);
    },
  }
}
</script>